import React, { Fragment } from 'react';

import EditIcon from '@usas/ui-web/components/icons/EditIcon';

import { formatDate } from '@usas/ui-web/utils/DateFunctions';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GridRow = ({ approvedMeetRequest, onApprovedRequestClicked }) => (
  <div className={global.SmallTableRow}>
    <div className={global.SmallTableRowHead}>
      <span className='hidden-xs'>{`${approvedMeetRequest.lscCode || ''} - ${approvedMeetRequest.clubName || ''}/${approvedMeetRequest.clubCode || ''}`}</span>&nbsp;
      <button
        className={global.IconButton}
        type="button"
        onClick={e => onApprovedRequestClicked(e, approvedMeetRequest)}>
        <EditIcon />
      </button>
    </div>
    <div className={global.SmallTableRowInfo}>
      <div className='row'>
        <div className={[global.SmallTableRowLabels, 'col-xs-12 visible-xs'].join(' ')}>LSC - Club Name/Club Code</div>
        <div className={[global.SmallTableRowData, 'col-xs-12 visible-xs'].join(' ')}>{`${approvedMeetRequest.lscCode || ''} - ${approvedMeetRequest.clubName || ''}/${approvedMeetRequest.clubCode || ''}`}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Submitted Date</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{formatDate(approvedMeetRequest.submissionDate)}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Meet Name</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{approvedMeetRequest.meetName}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Meet Dates</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-9'].join(' ')}>{`${formatDate(approvedMeetRequest.meetStartDate)} - ${formatDate(approvedMeetRequest.meetEndDate)}`}</div>
      </div>
    </div>
  </div>
);

const SmallGrid = ({ data, isLoading, onApprovedRequestClicked }) => (
  <Fragment>
    <div className={[global.SmallTable, 'hidden-lg hidden-md'].join(' ')}>
      {isLoading === true
        ? (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>&nbsp;</div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>Loading...</div>
            </div>
          </div>
        )
        : data.length > 0
          ? data.map((approvedMeetRequest, i) => <GridRow key={i} approvedMeetRequest={approvedMeetRequest} onApprovedRequestClicked={onApprovedRequestClicked} />)
          : (
            <div className={global.SmallTableRow}>
              <div className={global.SmallTableRowHead}>&nbsp;</div>
              <div className={global.SmallTableRowInfo}>
                <div className={global.SmallTableRowLabels}>No Approved Meet Requests</div>
              </div>
            </div>
          )
      }
    </div>
  </Fragment>
);

export default SmallGrid;